import {FC, ReactNode} from "react";
import {Checkbox, FormControlLabel} from "@mui/material";

interface IProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    /** Лейбл с ссылками (ReactNode). */
    label: ReactNode;
    error?: boolean;
    id: string;
}

/**
 * Одиночный чекбокс согласия. Не предзаполнен по умолчанию (управляется
 * родителем). Цвета — из темы (primary/ error). Лейбл — body2 через sx.
 */
const ConsentCheckbox: FC<IProps> = ({checked, onChange, label, error = false, id}) => (
    <FormControlLabel
        sx={{
            alignItems: "flex-start",
            m: 0,
            "& .MuiFormControlLabel-label": {
                fontSize: "0.8125rem",
                lineHeight: 1.5,
                color: "text.secondary",
                pt: "7px",
            },
        }}
        control={
            <Checkbox
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                size="small"
                color={error ? "error" : "primary"}
                sx={{
                    pt: "5px",
                    color: error ? "error.main" : "text.disabled",
                }}
            />
        }
        label={label}
    />
);

export default ConsentCheckbox;
